import { render, staticRenderFns } from "./ImagenesEventos.vue?vue&type=template&id=6c276fbc&scoped=true"
import script from "./ImagenesEventos.vue?vue&type=script&lang=js"
export * from "./ImagenesEventos.vue?vue&type=script&lang=js"
import style0 from "./ImagenesEventos.vue?vue&type=style&index=0&id=6c276fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c276fbc",
  null
  
)

export default component.exports